
import React, { useState, useEffect, useMemo, useRef } from 'react'
import { Formik } from 'formik';
import Swal from "sweetalert2"
import Breadcrums from '../../components/company_panel/common/breadcrumbs';
import $ from 'jquery';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { capitalizeAllFirstLetters, capitalizeFirstLetter, formateDate, getBrandId, getCompany, getOutletBusinessDate, getOutletId } from '../../helpers/commonFunctions';
import { getAllUoms } from '../../services/company_panel/setting/uomConfigurationService';
import { GetAllChildCategories, GetParentCategories } from '../../services/company_panel/categoryService';
import { useNavigate, useParams } from 'react-router-dom';
import { GetAllInventories, GetSingleInventory } from '../../services/company_panel/inventoryService';
import { AllWasteReason, WasteAdd } from '../../services/company_panel/wasteManagement.services';
import { getAllMenuItems } from '../../services/company_panel/mealService';
import { GetOrdersList } from '../../services/company_panel/orderService';
import { Dropdown } from 'semantic-ui-react';

const AddWaste = () => {
  // page the user was on in the list (carried in the route) so we return there
  const params = useParams();
  const listPage = params?.pgno || 1;
  const breadcrumbs = [{ title: "Waste Management", url: `/company/store_manager/waste_management/list/${listPage}` }, { title: "Add Wastes", url: "" },]
  const [submitted, setSubmitted] = useState(false)
  const [inventoryData, setInventoryData] = useState([]);
  const navigate = useNavigate();
  const [isBrandChanged, setIsBrandChanged] = useState(false);
  const [menuItemsData, setMenuItemsData] = useState([]);
  const [reasonData, setReasonData] = useState([]);
  const [isOutletChanged, setIsOutletChanged] = useState(false);
  const [ordersData, setOrdersData] = useState([]);
  const [ordersHasMore, setOrdersHasMore] = useState(true);
  const ORDERS_PER_PAGE = 10;
  const ordersPageRef = useRef(1);
  const ordersHasMoreRef = useRef(true);
  const ordersLoadingRef = useRef(false);
  const ordersCountRef = useRef(0);
  const ordersBaseLoadedRef = useRef(0);
  const triedOrderSearches = useRef(new Set());
  const ordersSearchTimer = useRef(null);
  const businessDate = getOutletBusinessDate();

  const generateOrderId = (orderId) => {
    let id = orderId;
    let countOfDigits = 0;
    while (id) {
      id = Math.floor(id / 10);
      countOfDigits += 1;
    }
    if (countOfDigits >= 4) {
      return orderId;
    }
    let zerosCount = 4 - countOfDigits;
    let generatedZeros = '';
    while (zerosCount) {
      generatedZeros += '0';
      zerosCount -= 1;
    }
    return `${generatedZeros}${orderId}`;
  };

  const emptyRow = { item_type: '', item_name: '', menu_item_name: '', quantity: '', unit_of_usage: '', reason_for_waste: '', order_id: '', remarks: '' };

  useMemo(() => {
    document.addEventListener('brand-changed', function () {
      setIsBrandChanged(!isBrandChanged);
    });
    document.addEventListener('outlet-changed', function () {
      setIsOutletChanged(!isOutletChanged);
    })
  });

  useEffect(() => {
    const formData = new FormData()
    formData.append('brand_id', getBrandId());
    GetAllInventories(formData).then(data => {
      setInventoryData(data && data.data && data.data.response ? data.data.response.rows : [])
    }).catch(error => {
      console.log("error ====> ", error);
    })
  }, [isBrandChanged])

  const generateSKU = (length = 8, setFieldValue) => {

    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let sku = '';
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters?.length);
      sku += characters[randomIndex];
    }
    setFieldValue('sku', sku);
  }

  const fetchUsageUnit = (id, idx, setFieldValue) => {
    if (!id) {
      setFieldValue(`items.${idx}.unit_of_usage`, '');
      return;
    }
    const formData = new FormData();
    formData.append('id', id);
    formData.append('outlet_id', getOutletId());
    GetSingleInventory(formData).then(data => {
      const usageUnit = data.data.response?.inventory_unit_converisons?.find(unit => unit?.unit_type === "Usage Unit");
      const UsageData = capitalizeFirstLetter(usageUnit?.uomDetail?.uom)
      setFieldValue(`items.${idx}.unit_of_usage`, UsageData || '');
    }).catch(error => {
      console.log("error ====> ", error);
    });
  };

  useEffect(() => {
    getAllMenuItems({ brand_id: getBrandId() }).then(data => {
      if (data && data.data && data.data.response) {
        setMenuItemsData(data.data.response.rows);
      }
    }).catch(error => {
      console.log("error=====>", error);
    });
  }, [isBrandChanged]);

  useEffect(() => {
    setTimeout(() => {
      AllWasteReason({ brand_id: getBrandId() }).then(data => {
        if (data && data.data && data.data.response) {
          setReasonData(data.data.response);
        }
      }).catch(error => {
        console.log("error=====>", error);
      });
    }, 400)
  }, [isBrandChanged]);

  const ordersFormData = (page, search) => {
    const bDate = getOutletBusinessDate();
    const start_date = new Date(new Date(bDate).setHours(0, 0, 0, 0));
    const end_date = new Date(new Date(bDate).setHours(23, 59, 59, 999));
    const formData = new FormData();
    formData.append("page", page);
    formData.append("per_page", ORDERS_PER_PAGE);
    formData.append("sort", JSON.stringify({}));
    formData.append("search", JSON.stringify({ created: { start: start_date.toISOString(), end: end_date.toISOString() } }));
    formData.append("global_search", search || "");
    formData.append('outlet_id', getOutletId());
    formData.append('brand_id', getBrandId());
    return formData;
  };

  // Base business-date list with infinite scroll (no search) - this is the master list.
  const fetchOrders = (page, append) => {
    if (ordersLoadingRef.current) return;
    ordersLoadingRef.current = true;
    GetOrdersList(ordersFormData(page, '')).then(data => {
      const rows = data && data.data && data.data.response ? data.data.response.rows : [];
      const count = data && data.data && data.data.response ? data.data.response.count : 0;
      ordersCountRef.current = count;
      ordersBaseLoadedRef.current = append ? ordersBaseLoadedRef.current + rows.length : rows.length;
      setOrdersData(prev => {
        if (!append) return rows;
        const existingIds = new Set(prev.map(r => r.id));
        return [...prev, ...rows.filter(r => !existingIds.has(r.id))];
      });
      ordersHasMoreRef.current = ordersBaseLoadedRef.current < count;
      setOrdersHasMore(ordersBaseLoadedRef.current < count);
      ordersPageRef.current = page;
      ordersLoadingRef.current = false;
    }).catch(error => {
      console.log("error=====>", error);
      ordersLoadingRef.current = false;
    });
  };

  const loadMoreOrders = () => {
    if (ordersLoadingRef.current || !ordersHasMoreRef.current) return;
    fetchOrders(ordersPageRef.current + 1, true);
  };

  const orderOptionText = (row) => `#order ${generateOrderId(row.id)}`;

  // One-shot server lookup for a query with no local match; merges results into the master list.
  const lookupOrderOnServer = (q) => {
    if (ordersLoadingRef.current || triedOrderSearches.current.has(q)) return;
    triedOrderSearches.current.add(q);
    ordersLoadingRef.current = true;
    GetOrdersList(ordersFormData(1, q)).then(data => {
      const rows = data && data.data && data.data.response ? data.data.response.rows : [];
      if (rows.length) {
        setOrdersData(prev => {
          const existingIds = new Set(prev.map(r => r.id));
          const fresh = rows.filter(r => !existingIds.has(r.id));
          return fresh.length ? [...prev, ...fresh] : prev;
        });
      }
      ordersLoadingRef.current = false;
    }).catch(error => {
      console.log("error=====>", error);
      ordersLoadingRef.current = false;
    });
  };

  const handleOrderSearch = (e, { searchQuery }) => {
    if (ordersSearchTimer.current) clearTimeout(ordersSearchTimer.current);
    ordersSearchTimer.current = setTimeout(() => {
      const q = (searchQuery || '').trim();
      if (!q) return;
      // 1) Always check the client first - if the master list already has a partial match, no API.
      const hasLocalMatch = ordersData.some(row => orderOptionText(row).toLowerCase().includes(q.toLowerCase()));
      if (hasLocalMatch) return;
      // 2) No local match -> one server lookup for this exact query (guarded against repeats).
      lookupOrderOnServer(q);
    }, 400);
  };

  useEffect(() => {
    ordersPageRef.current = 1;
    ordersHasMoreRef.current = true;
    ordersCountRef.current = 0;
    ordersBaseLoadedRef.current = 0;
    triedOrderSearches.current = new Set();
    fetchOrders(1, false);
  }, [isBrandChanged, isOutletChanged]);

  useEffect(() => {
    const handleMenuScroll = (e) => {
      const el = e.target;
      if (el && el.classList && el.classList.contains('menu') && el.closest && el.closest('.orders-dropdown')) {
        if (el.scrollTop + el.clientHeight >= el.scrollHeight - 24) {
          loadMoreOrders();
        }
      }
    };
    document.addEventListener('scroll', handleMenuScroll, true);
    return () => document.removeEventListener('scroll', handleMenuScroll, true);
  }, []);


  return (
    <>
      <div className="page-header d-flex align-items-center">
        <div className="page-header-left">
          <Breadcrums data={breadcrumbs} />
        </div>
        <div className="page-header-right ms-auto">
          <span className="d-inline-flex align-items-center gap-2 px-3 py-2 rounded" style={{ background: '#eaf4ff', border: '1px solid #2f9bff' }}>
            <span style={{ fontSize: '0.95rem', color: '#475569' }}>Business Date:</span>
            <span style={{ fontSize: '1.25rem', fontWeight: 700, color: '#2f9bff' }}>{formateDate(businessDate, false)}</span>
          </span>
        </div>
      </div>
      <Formik
        initialValues={{
          items: [{ ...emptyRow }],
        }}
        validate={values => {
          const errors = {};
          const itemsErrors = (values.items || []).map(item => {
            const e = {};
            if (!item.item_type) e.item_type = "Item type is required";
            if (item.item_type === 'raw-material' && !item.item_name) e.item_name = "Item name is required";
            if (item.item_type === 'production' && !item.menu_item_name) e.menu_item_name = "Menu item name is required";
            if (item.quantity === '' || item.quantity === null || item.quantity === undefined) {
              e.quantity = "Quantity is required";
            } else if (Number(item.quantity) < 0) {
              e.quantity = "Quantity cannot be negative";
            } else if (item.quantity.toString().length > 8) {
              e.quantity = "Quantity cannot be more than 8 digits";
            }
            if (!String(item.reason_for_waste || '').trim()) {
              e.reason_for_waste = "Reason for waste is required";
            }
            if (item.item_type === 'production' && !item.order_id) {
              e.order_id = "Order is required";
            }
            return e;
          });
          if (itemsErrors.some(e => Object.keys(e).length)) {
            errors.items = itemsErrors;
          }
          return errors;
        }}
        onSubmit={(values) => {
          setSubmitted(true)
          const payload = values.items.map(item => ({
            item_type: item.item_type,
            inventory_id: item.item_type === 'raw-material' ? item.item_name : null,
            menu_item_id: item.item_type === 'production' ? item.menu_item_name : null,
            quantity: item.quantity,
            unit_of_usage: item.unit_of_usage || '',
            reason_for_waste: String(item.reason_for_waste).trim(),
            order_id: item.order_id || null,
            remarks: item.remarks ? String(item.remarks).trim() : '',
          }));
          let formData = new FormData();
          formData.append('data', JSON.stringify(payload));
          formData.append('company_id', getCompany().company_id);
          formData.append('outlet_id', getOutletId());
          WasteAdd(formData).then(response => {
            setSubmitted(false);
            if (response.data.status === 1 || response.data.status === "1") {
              Swal.fire({
                customClass: 'swal-wide',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 1500,
                toast: true,
                position: 'top-right',
              });
              setTimeout(() => {
                navigate(`/company/store_manager/waste_management/list/${listPage}`)
              }, 1000);
            } else {
              Swal.fire({
                customClass: 'swal-wide',
                icon: 'error',
                title: response.data.message,
                showConfirmButton: false,
                timer: 5000,
                toast: true,
                position: 'top-right',
              })
            }
          }).catch(error => {
            console.log("error ====> ", error);
            setSubmitted(false);
            Swal.fire({
              customClass: 'swal-wide',
              icon: 'error',
              title: error.response.data.errors.message,
              showConfirmButton: false,
              timer: 5000,
              toast: true,
              position: 'top-right',
            })
          })
        }}
      >{({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit}>
          <div className="card custom-card">
            <div className="card-body">
              {values.items.map((item, idx) => {
                const rowErrors = (errors.items && errors.items[idx]) || {};
                const rowTouched = (touched.items && touched.items[idx]) || {};
                return (
                  <div key={idx} className='row mb-3 p-3 border rounded position-relative'>
                    <div className='col-lg-3 text-center form-group mb-3'>
                      <label className='text-left d-flex'>Item Type<span className="requirestar">*</span></label>
                      <select
                        className='form-control'
                        name={`items.${idx}.item_type`}
                        onChange={(e) => {
                          setFieldValue(`items.${idx}.item_type`, e.target.value);
                          setFieldValue(`items.${idx}.item_name`, '');
                          setFieldValue(`items.${idx}.menu_item_name`, '');
                          setFieldValue(`items.${idx}.unit_of_usage`, '');
                        }}
                        onBlur={handleBlur}
                        value={item.item_type}
                      >
                        <option value="">Select Item Type</option>
                        <option value="raw-material">Raw material</option>
                        <option value="production">Production</option>
                      </select>
                      <span className='text-danger d-flex text-left'>{rowErrors.item_type && rowTouched.item_type && rowErrors.item_type}</span>
                    </div>

                    {item.item_type === 'raw-material' && (
                      <div className='col-lg-3 text-center form-group mb-3'>
                        <label className='text-left d-flex'>Item Name<span className="requirestar">*</span></label>
                        <Dropdown
                          className='form-control'
                          placeholder='Select Item Name'
                          search
                          fluid
                          selection
                          options={inventoryData.map((row) => ({
                            key: row.id,
                            value: row.id,
                            text: `${capitalizeAllFirstLetters(row.item_name)}${row.sku ? ` (SKU: ${row.sku})` : ''}`,
                          }))}
                          value={item.item_name}
                          onBlur={handleBlur}
                          onChange={(event, data) => { setFieldValue(`items.${idx}.item_name`, data.value); fetchUsageUnit(data.value, idx, setFieldValue); }}
                        />
                        <span className='text-danger d-flex text-left'>{rowErrors.item_name && rowTouched.item_name && rowErrors.item_name}</span>
                      </div>
                    )}

                    {item.item_type === 'production' && (
                      <div className='col-lg-3 text-center form-group mb-3'>
                        <label className='text-left d-flex'>Menu Item Name<span className="requirestar">*</span></label>
                        <Dropdown
                          className='form-control'
                          placeholder='Select Item Name'
                          search
                          fluid
                          selection
                          options={menuItemsData.map((row) => ({
                            key: row.id,
                            value: row.id,
                            text: capitalizeAllFirstLetters(row.item_name),
                          }))}
                          value={item.menu_item_name}
                          onBlur={handleBlur}
                          onChange={(event, data) => { setFieldValue(`items.${idx}.menu_item_name`, data.value); }}
                        />
                        <span className='text-danger d-flex text-left'>{rowErrors.menu_item_name && rowTouched.menu_item_name && rowErrors.menu_item_name}</span>
                      </div>
                    )}

                    <div className='col-lg-3 text-center form-group mb-3'>
                      <label className='text-left d-flex'>Quantity<span className="requirestar">*</span></label>
                      <input
                        name={`items.${idx}.quantity`}
                        type='number'
                        placeholder='Enter Quantity'
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={item.quantity}
                        className='form-control'
                      />
                      <span className='text-danger d-flex text-left'>{rowErrors.quantity && rowTouched.quantity && rowErrors.quantity}</span>
                    </div>

                    {item.item_type === 'raw-material' && (
                      <div className='col-lg-3 text-center form-group mb-3'>
                        <label className='text-left d-flex'>Unit Of Usage</label>
                        <input
                          name={`items.${idx}.unit_of_usage`}
                          type='text'
                          placeholder='Unit'
                          value={item.unit_of_usage}
                          disabled
                          className='form-control'
                        />
                      </div>
                    )}

                    <div className='w-100'></div>

                    <div className='col-lg-3'>
                      <div className='text-center form-group mb-3'>
                        <label className='text-left d-flex'>Reason<span className="requirestar">*</span></label>
                        <select
                          className='form-control'
                          name={`items.${idx}.reason_for_waste`}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={item.reason_for_waste}
                        >
                          <option value="">Select Reason</option>
                          {reasonData?.length ? reasonData.map((row) => (
                            <option key={row.id} value={row.id}>{capitalizeAllFirstLetters(row.reason)}</option>
                          )) : ''}
                        </select>
                        <span className='text-danger d-flex text-left'>{rowErrors.reason_for_waste && rowTouched.reason_for_waste && rowErrors.reason_for_waste}</span>
                      </div>

                      <div className='text-center form-group mb-0'>
                        <label className='text-left d-flex'>Order{item.item_type === 'production' && <span className="requirestar">*</span>}</label>
                        <Dropdown
                          className='form-control orders-dropdown'
                          placeholder='Select Order'
                          search
                          fluid
                          selection
                          scrolling
                          clearable
                          onSearchChange={handleOrderSearch}
                          noResultsMessage={ordersHasMore ? 'Loading...' : 'No orders found for this business date'}
                          options={ordersData.map((row) => ({
                            key: row.id,
                            value: row.id,
                            text: orderOptionText(row),
                          }))}
                          value={item.order_id}
                          onBlur={handleBlur}
                          onChange={(event, data) => { setFieldValue(`items.${idx}.order_id`, data.value); }}
                        />
                        {item.item_type === 'production' && (
                          <span className='text-danger d-flex text-left'>{rowErrors.order_id && rowTouched.order_id && rowErrors.order_id}</span>
                        )}
                      </div>
                    </div>

                    <div className='col-lg-9 d-flex flex-column'>
                      <div className='form-group mb-2'>
                        <label className='text-left d-flex'>Remarks</label>
                        <textarea
                          name={`items.${idx}.remarks`}
                          rows={4}
                          placeholder='Enter Remarks (optional)'
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={item.remarks}
                          className='form-control'
                        />
                      </div>
                      <div className='d-flex justify-content-end mt-auto'>
                        <button
                          type='button'
                          className='btn btn-icon btn-outline-danger'
                          disabled={values.items.length === 1}
                          onClick={() => {
                            const next = values.items.filter((_, i) => i !== idx);
                            setFieldValue('items', next);
                          }}
                          title='Remove item'
                        >
                          <i className='ti ti-trash' style={{ color: '#dc3545' }}></i>
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}

              <div className='mb-3'>
                <button
                  type='button'
                  className='btn btn-secondary'
                  onClick={() => setFieldValue('items', [...values.items, { ...emptyRow }])}
                >
                  <i className='ti ti-plus'></i> Add Item
                </button>
              </div>

              <div className="mt-2">
                <button className="btn btn-primary mr-2" type="submit" disabled={submitted ? true : null}>
                  Submit
                </button>
              </div>
            </div>
          </div>
        </form>
      )}
      </Formik>
      <ToastContainer
        position="top-right"
        hideProgressBar={false}
        autoClose={true | 1000}
        newestOnTop={true}
        closeOnClick={false}
        draggable={false}
        rtl={false}
      />
    </>
  );
}

export default AddWaste